import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Link from 'shared/components/Link/Link';
import MakesSidebar from 'desktop/components/MakesSidebar/MakesSidebar';
import s from './NotFound.css';
import history from '../../../history';
import SPECIAL from '../../constants/special';

import errorImage from './error.jpg';
import SpecialAdverts from '../home/components/SpecialAdverts/SpecialAdverts';

class NotFound extends React.Component {
  static propTypes = {
    specialCars: PropTypes.shape({
      vipCars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      lowPriceCars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      europeCars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    }).isRequired,
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.imageContainer}>
            <img className={s.image} alt="Error message" src={errorImage} />
          </div>

          <div className={s.content}>
            <h1 className={s.title}>{this.props.title}</h1>
            <p>
              <FormattedMessage id="Адрес набран неправильно или страницы больше не существует" />
            </p>
            <FormattedMessage id="Вы можете" />{' '}
            <Link className={s.link} to="/">
              <FormattedMessage id="Перейти на главную" />
            </Link>
            {`  `}
            <FormattedMessage id="или" />
            {`  `}
            <span className={s.link} onClick={history.goBack}>
              <FormattedMessage id="вернуться назад" />
            </span>
          </div>
        </div>
        <div className={s.makeContainer}>
          <MakesSidebar itemCN={s.makeItem} />
        </div>
        <SpecialAdverts cars={this.props.specialCars} specialLinks={SPECIAL.MAIN} />
      </div>
    );
  }
}

export default withStyles(s)(NotFound);



// WEBPACK FOOTER //
// ./src/desktop/routes/not-found/NotFound.js